import { IActivity } from '../../../../../../../../../../../store/features/activity/interface/IActivityList'

export const findActivityUuid = (
  activityList: IActivity[], activityId: number,
): string => {
  const activityItem = activityList.find((a) => a.id === activityId)
  return activityItem ? activityItem.activityUuid : ''
}
